import mainStyle from "../../mainStyle.module.scss";
import sliderStyle from "./slider.module.scss";

import icn_close from "assets/images/icons/icn_close.svg";
import img_device_camera from "assets/images/icons/img_device_camera.svg";
import img_device_nvr from "assets/images/icons/img_device_nvr.svg";

import { Box, Tabs, Tab } from "@mui/material";

import { surveillanceDeviceTypeOption } from "../../const";
import { getDefaultTabProp } from "../../../theme";
import Overview from "./Overview";

const Slider = ({
  openSlider,
  onToggleSlider,
  device,
  authenticateDevice,
  authenticatingDeviceId,
  showAuthenticationError,
  openAdoption,
}) => {
  if (!device) {
    return null;
  }

  const isNvr = device.deviceType?.value === surveillanceDeviceTypeOption.nvr.value;

  return (
    <div className={`${sliderStyle["slider-info"]} ${openSlider ? sliderStyle.open : ""}`}>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Box display="flex" justifyContent="flex-start" alignItems="center">
          <img src={isNvr ? img_device_nvr : img_device_camera} alt="" />
          <Box className={sliderStyle["model-name-container"]}>
            <Box className={sliderStyle["model-name"]}>
              {device.modelName || "Device"}
            </Box>
            <Box className={`${mainStyle["chip-name"]} ${mainStyle[`${device.status?.value}-chip`]} ${sliderStyle["chip-name"]}`}>
              {device.status?.label || "Unmanaged"}
            </Box>
          </Box>
        </Box>
        <Box>
          <img src={icn_close} alt="" className={sliderStyle.close} onClick={onToggleSlider} />
        </Box>
      </Box>

      <Box>
        <Tabs
          value="overview"
          TabIndicatorProps={{ ...getDefaultTabProp().tabIndicatorProps }}
          sx={{ ...getDefaultTabProp().sx }}
        >
          <Tab value="overview" label="Overview" />
        </Tabs>
      </Box>

      <Box sx={{ padding: "16px 8px" }}>
        <Overview
          device={device}
          authenticateDevice={authenticateDevice}
          authenticatingDeviceId={authenticatingDeviceId}
          showAuthenticationError={showAuthenticationError}
          openAdoption={openAdoption}
        />
      </Box>
    </div>
  );
};

export default Slider;
